export default {"src":"/_next/static/media/company6.9153d48d.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};